/* WF Transparent Header: measure height, preserve original colors, handle search modal */
(function(){
  var hdr = document.querySelector('.site-header--transparent');
  if (!hdr) return;

  function measure() {
    var wrapper = hdr.closest('.shopify-section') || hdr;
    var announcementHeight = 0;
    var prev = wrapper.previousElementSibling;

    while (prev) {
      /* Only count visible shopify-section wrappers (announcement bars) */
      if (prev.offsetHeight > 0 && prev.classList.contains('shopify-section')) {
        announcementHeight += prev.offsetHeight;
        prev.style.position = 'relative';
        prev.style.zIndex = '1000';
      }
      prev = prev.previousElementSibling;
    }

    /* Position header below announcement bars */
    hdr.style.top = announcementHeight + 'px';

    /* Total offset = announcements + header */
    var totalHeight = announcementHeight + hdr.offsetHeight;
    document.documentElement.style.setProperty('--wf-header-height', totalHeight + 'px');
  }
  measure();
  window.addEventListener('resize', measure);



  /* Search modal open/close */
  var modal = document.getElementById('wf-search-modal');
  if (modal) {
    document.querySelectorAll('[data-wf-search-open]').forEach(function(btn){
      btn.addEventListener('click', function(){
        modal.style.display = 'flex';
        var input = modal.querySelector('.wf-search-modal__input-wrapper input');
        if (input) input.focus();
      });
    });
    document.querySelectorAll('[data-wf-search-close]').forEach(function(btn){
      btn.addEventListener('click', function(){
        modal.style.display = 'none';
      });
    });
    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && modal.style.display !== 'none') {
        modal.style.display = 'none';
      }
    });
  }
})();
